<template>
  <a :href="href">
    <Flex center gap-3 class="cursor-pointer px-4 py-2 rounded-xl" :class="classes">
      <Flex center class="w-4 text-[0.1em]" v-for="i in h" :key="i"/>
      <Flex center class="w-4">
        <i :class="props.item.icon" />
      </Flex>
      <div class="grow" v-if="!props.small">
        {{ props.item.name }}
      </div>
      <Flex center class="w-4" v-if="!props.small && props.item.childrens?.length > 0">
        <ChevronX v-model="props.item.expanded" />
      </Flex>
    </Flex>
  </a>
</template>

<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    item: Object,
    small: Boolean,
    h: {
      type: Number,
      default: 0,
    },
    selected: Boolean,
    open: Boolean,
    href: String,
  })

  const classes = computed(() => {
    return [
      { 'bg-primary-800 text-white hover:bg-primary-600': props.selected && !props.open },
      { 'hover:bg-gray-100 hover:text-primary-800': !props.selected && !props.open },
      { 'text-primary-800 hover:bg-primary-50': props.open },
      { 'text-gray-500': !props.open },
    ]
  })
</script>
